var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2 margin-left bg-panel"},[_c('sidebar')],1),_c('div',{staticClass:"column router_view"},[_c('router-view')],1)]),_c('buttonLine')],1)}
var staticRenderFns = []

export { render, staticRenderFns }